<template>
  <div id="footer" class="container-fluid1">
    <div class="information-box">
      <div class="footer-left-box">
        <div class="logo"><img src="@/assets/img/home/logo1.png" /></div>
        <div class="text">
          <p>
            Copyright © Guangdong Cyberway Information Technology Co., Ltd. All
            rights reserved.
          </p>
          <p>Unauthorized use is prohibited and will be prosecuted.</p>
        </div>
      </div>
      <div class="footer-right-box">
        <div class="logos">
          <div class="logo2" @click="jumpTo('https://www.youtube.com/@%E8%B5%9B%E5%8D%9A%E5%A8%81')"></div>
          <div class="logo3" @click="jumpTo('https://www.facebook.com/profile.php?id=61559555078717')"></div>
        </div>
        <div class="text">
          <p>400-168-0262</p>
          <p>
            <a
              href="mailto:Marketing@cyberway.net.cn"
              rel="noreferrer"
              target="_blank"
              >Marketing@cyberway.net.cn</a
            >
          </p>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="center">
        <div class="left-box" @click="jumpTo('https://beian.miit.gov.cn')">
          粤ICP备17158128号-20
        </div>
        <div class="right-box">
          <a href="https://beian.miit.gov.cn" target="_blank">
            <div class="txt txt1"></div>
          </a>
          <div class="txt" @click="jumpTo('https://beian.mps.gov.cn/#/query/webSearch?code=44011202003090')">
            <img v-lazy="require('@/assets/img/footer/icon.png')" />粤公网安备案 44011202003090号</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    jumpTo(url) {
      window.open(url);
    }
  }
};
</script>
<style scoped lang="scss">
#footer {
  width: 100%;
  color: #fff;
  background: #202329;
  overflow: hidden;
  text-align: center;
  animation: wait-in 3s ease;
}
.container-fluid1 {
  position: relative;
  .information-box {
    width: 1370px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 62px 0;
    .footer-left-box {
      width: 970px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .logo {
        margin-top: -7px;
        width: 51px;
        height: 51px;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        margin-left: 21px;
        p {
          font-size: 18px;
          color: #bcbcbc;
          text-align: left;
          line-height: 1;
          font-family: MiSans-Regular, MiSans-Regular;
        }
      }
    }
    .footer-right-box {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .logos {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .logo2 {
          width: 40px;
          height: 29px;
          margin-right: 18px;
          background: url("../assets/img/home/logo2.png") no-repeat center;
          background-size: contain;
          cursor: pointer;
          //margin-top: 12px;

          // img {
          //   width: 100%;
          //   height: 100%;
          // }
          &:hover {
            background: url("../assets/img/home/logo2b.png") no-repeat center;
            background-size: contain;
          }
        }
        .logo3 {
          width: 34px;
          height: 34px;
          background: url("../assets/img/home/logo3.png") no-repeat center;
          background-size: contain;
          cursor: pointer;

          // img {
          //   width: 100%;
          //   height: 100%;
          // }
          &:hover {
            background: url("../assets/img/home/logo3b.png") no-repeat center;
            background-size: contain;
          }
        }
      }
      .text {
        margin-left: 30px;
        cursor: pointer;
        p {
          font-size: 18px;
          line-height: 1;
          color: #bcbcbc;
          text-align: left;
          font-family: MiSans-Regular, MiSans-Regular;
          &:hover {
            color: #fff;
          }
        
          a {
            // 禁用下划线
            text-decoration: none;
            color: #bcbcbc;
            &:hover {
            color: #fff;
          }
          }
        }

      }
    }
  }
  .bottom-box {
    width: 100%;
    height: 84px;
    padding-top: 26px;
    background-color: #191c21;
    .center {
      margin: 0 auto;
      width: 560px;
      //width:100%;

      display: flex;
      flex-wrap: wrap;
      .left-box {
        font-size: 18px;
        color: #bcbcbc;
        font-family: "MiSans-Regular-";
        margin-right: 70px;
        //width:100%;
       // flex: 1;
        text-align: left;
        cursor: pointer;
        &:hover {
            color: #fff;
          }
      }
      .right-box {
        flex: 1;
        display: flex;
        justify-content: space-between;
        cursor: pointer;

        // a {
        //   // 禁用下划线
        //   text-decoration: none;
        //   color: #bcbcbc;
        // }
        .txt {
          font-size: 18px;
          color: #bcbcbc;
          font-family: "MiSans-Regular-";
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 18px;
            margin-right: 4px;
          }
          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}

/* 定义动画 */
@keyframes wait-in {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue